import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PdfJob } from '../models/pdf-job.interface';
import { AoAuthService } from '@ah-oh/company-auth';

@Injectable({
    providedIn: 'root',
})
export class PdfApiService {
    private static readonly BASE_URL = environment.api + 'pdf-management';

    constructor(
        private readonly http: HttpClient,
        private readonly authService: AoAuthService,
    ) {}

    public downloadPdf({ jobId }: { jobId: string }): Observable<any> {
        return this.http.get(`${PdfApiService.BASE_URL}/${this.authService.companyId}/${jobId}`, {
            responseType: 'blob',
            observe: 'response',
        });
    }

    public findAllPdfJobs(): Observable<PdfJob[]> {
        return this.http.get<PdfJob[]>(`${PdfApiService.BASE_URL}/${this.authService.companyId}`);
    }

    public delete({ jobId }: { jobId: string }): Observable<PdfJob> {
        return this.http.delete<PdfJob>(`${PdfApiService.BASE_URL}/${this.authService.companyId}/${jobId}`);
    }
}
